import React from 'react';

export const highlightStringMatches = (text: string, query?: string) => {
	if (!query) return text;
	const newQuery = query.replace('+', '\\+');
	const regex = new RegExp(`(${newQuery})`, 'gi');
	const parts = text.split(regex);

	return parts
		.filter((part) => part)
		.map((part, index) =>
			regex.test(part) ? (
				<span key={index} className="bg-cyan-200 font-bold">
					{part}
				</span>
			) : (
				<span key={index}>{part}</span>
			)
		);
};
